export default __webpack_public_path__ + "static/media/like.19ec3eb7.svg";